import Link from 'gatsby-link'
import styled from 'styled-components'

import { RewardsCard as BaseCard, RewardsCardHeader } from '../../../RewardsCard'

export const Card = styled(BaseCard)`
  gap: 24px;
  margin-top: 48px;
  background-color: #5496e51a;
  @media (max-width: 768px) {
    margin-top: 8px;
  }
`

export const Header = styled(RewardsCardHeader)`
  @media (min-width: 1024px) {
    flex-direction: row;
    gap: unset;
  }
`

export const Heading2 = styled.h2`
  font-size: 20px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.text.primary};
  margin: 0;
  font-family: ${({ theme }) => theme.fontFamilies.gotham};
`
export const ProgramDetailsLink = styled(Link)`
  font-family: ${({ theme }) => theme.fontFamilies.robotoCondensed};
  font-size: 16px;
  font-weight: 500;
  line-height: 18.75px;
  color: ${({ theme }) => theme.colors.brand.blue};
  text-decoration: underline;
  margin-left: auto;

  &:hover {
    color: ${({ theme }) => theme.colors.blue.light350};
  }
  @media (max-width: 768px) {
    pading-top: 8px;
    margin-left: 0;
  }
`

export const ClassificationsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media (min-width: 1024px) {
    flex-direction: row;
    justify-content: space-between;
  }
`
